import React from 'react'
import { EmptyState } from '@enamelai/design-system'
import './CreateFormEmptyState.css'

interface CreateFormEmptyStateProps {
  onCreateForms: () => void
}

const CreateFormEmptyState: React.FC<CreateFormEmptyStateProps> = ({
  onCreateForms,
}) => (
  <EmptyState
    className="create-form-empty"
    iconClass="mgc mgc_document_fill"
    title="No forms yet"
    description="Click below to create form templates."
    actionLabel="Create form"
    onAction={onCreateForms}
  />
)

export default CreateFormEmptyState
